import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'suka-stack',
  template: `
    <div
      class="
        stack__wrapper
        stack--spacing-{{spacing}}
        stack--distribution-{{distribution}}
        stack--alignment-{{alignment}}
      "
      [ngClass]="{
        'stack--vertical': vertical,
        'stack--no-wrap': !wrap
      }"
    >
      <ng-content></ng-content>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class Stack {
  @HostBinding('class.stack') baseClass = true;

  /**
   * Make stack vertical (inverts axis of alignment and distribution inputs)
   */
  @HostBinding('class.stack--vertical') @Input() vertical = false;

  /**
   * Spacing between elements
   */
  @Input() spacing: 'tight' | 'loose' | 'default' | 'none' = 'default';

  /**
   * Horizontal alignment of elements (vertical alignment on vertical stack)
   */
  @Input() distribution: 'leading' | 'trailing' | 'equalSpacing' | 'center' | 'fill' | 'fillEvenly' = 'leading';

  /**
   * Vertical alignment of elements  (horizontal alignment on vertical stack)
   */
  @Input() alignment: 'leading' | 'trailing' | 'center' | 'fill' | 'baseline' = 'leading';

  /**
   * Wrap stack elements to additional rows as needed on small screens.
   */
  @Input() wrap = true;
}
